import $publicFn from "@/util/toolClass/publicFn";
import * as echarts from "echarts";
const getlineChart = (obj) => {
  const defaultConfig = {
    tooltip: {
      trigger: "axis",
      backgroundColor: "rgba(38,38,38,0.90)",
      borderColor: "rgba(38,38,38,0.90)",
      borderWidth: 1,
      borderRadius: 6,
      axisPointer: {
        type: "shadow" //背景色
      },
      extraCssText:
        "box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12); width: 220px;"
    },
    grid: {
      top: "5%",
      left: "2%",
      right: "2%",
      bottom: "0%",
      containLabel: true
    },
    textStyle: {
      fontFamily: "Montserrat-Regular"
    },

    xAxis: {
      type: "category",
      boundaryGap: false,
      axisTick: {
        show: false
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: "#F0F0F0",
          width: 1
        }
      },
      axisLabel: {
        rotate: 0,
        show: true,
        color: "#677392",
        fontFamily: "Montserrat-Regular",
        fontWeight: 400,
        fontSize: 12
      },
      splitLine: {
        show: false,
        lineStyle: {
          color: "#F0F0F0"
        }
      },
      data: obj.x
    },
    yAxis: {
      type: "value",
      axisLine: {
        lineStyle: {
          show: true,
          color: "#677392",
          fontFamily: "Montserrat-Regular",
          fontWeight: 400,
          fontSize: 12
        }
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: "#F0F0F0"
        }
      },
      axisLabel: {
        show: true,
        color: "#364366",
        fontFamily: "Montserrat-Regular",
        fontWeight: 400,
        fontSize: 12,
        formatter: value => {
          return $publicFn.formatNumberAddUnit(value);
        }
      }
    },
    series: [
      {
        data: obj.y,
        name: "View Counts",
        key: "view_count",
        type: "line",
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 1,
              color: "rgba(251,188,0,0)"
            },

            {
              offset: 0,
              color: "rgba(251,188,0,0.2)"
            }
          ])
        },
        smooth: true,
        showSymbol: false, //是否默认展示圆点

        emphasis: {
          showSymbol: false //是否默认展示圆点
        },
        itemStyle: {
          color: "#F9AD00"
        }
      }
    ]
  };

  const opt = Object.assign({}, defaultConfig);
  const { grid, tooltip, xAxis, yAxis, title, series } = opt;
  const chartOpt = {
    grid,
    tooltip,
    xAxis,
    yAxis,
    title,
    series
  };
  return chartOpt;
};

const getbarChartByday = (obj) => {
  const defaultConfig = {
    grid: {
      show: false,
      top: "5%",
      right: "5%",
      bottom: "15%",
      left: "15%"
    },
    tooltip: {
      trigger: "item",
      backgroundColor: "rgba(38,38,38,0.90)",
      borderColor: "rgba(38,38,38,0.90)",
      borderWidth: 1,
      borderRadius: 6
    },
    // color: ["#AE67FF"],
    legend: {
      show: false
    },
    textStyle: {
      fontFamily: "Montserrat-Regular"
    },
    xAxis: {
      type: "category",
      axisTick: {
        show: false
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: "#F0F0F0",
          width: 1
        }
      },
      axisLabel: {
        rotate: 30,
        show: true,
        color: "#677392",
        fontFamily: "Montserrat-Regular",
        fontWeight: 400,
        fontSize: 12
      },
      splitLine: {
        show: false,
        lineStyle: {
          color: "#F0F0F0"
        }
      },
      data: obj.x
    },
    yAxis: {
      type: "value",

      min: 0,
      // max: obj.max,
      splitNumber: 5,
      // interval: obj.interval,
      axisLine: {
        lineStyle: {
          show: true,
          color: "#677392",
          fontFamily: "Montserrat-Regular",
          fontWeight: 400,
          fontSize: 12
        }
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: "#F0F0F0"
        }
      },
      axisLabel: {
        show: true,
        color: "#364366",
        fontFamily: "Montserrat-Regular",
        fontWeight: 400,
        fontSize: 12,
        formatter: value => {
          return $publicFn.formatNumberAddUnit(value);
        }
      }
    },
    series: [
      {
        type: "bar",
        barMaxWidth: "20%",
        barMinWidth: 12,
        barMinHeight: 5,
        
        itemStyle: {
          borderWidth: 0,
          borderRadius: [4, 4, 0, 0]
        },
        labelLine: {
          show: false
        },
        data:obj.y
      }
    ]
  };

  const opt = Object.assign({}, defaultConfig);
  const { grid, tooltip, xAxis, yAxis, title, series } = opt;
  const chartOpt = {
    grid,
    tooltip,
    xAxis,
    yAxis,
    title,
    series
  };
  return chartOpt;
};
export default { getlineChart, getbarChartByday };



// WEBPACK FOOTER //
// ./src/components/chart/options/line/index.js